<template>
  <AppView
    body-class="tw-flex tw-flex-col"
    padd-bottom
  >
    <TopNav
      slot="top-app-view"
      :class="{ 'tw-shadow-app' : isMobileView }"
      :title="`${user.name || ''} ${user.last_name || ''}`"
      center-title
      title-class="lg:ml-body tw-tracking-wide font-title"
      type="back"
      :prev-route="prevRoute"
      :show-user-photo="false"
      @input="openSideNav()"
    >
      <UserPhoto
        v-if="user.photo"
        :photo="user.photo"
        photo-size="tw-h-6 tw-w-6"
        slot="title-left"
        class="tw-inline-block tw-mx-2"
      />
    </TopNav>
    <ChatPartial
      v-model.lazy="message"
      class="tw-pt-6"
      :id="userId"
      :lg-grid="true"
    />
  </AppView>
</template>

<script>
import ChatPartial from '@/views/_partials/Chat.vue';

export default {
  name: 'Chat',
  components: {
    ChatPartial,
  },
  props: ['id', 'prevRoute'],
  data() {
    return {
      loading: true,
      error: undefined,
      user: {},
      userId: this.id || this.$route.params.id,
    };
  },
  async created() {
    await this.$nextTick();
    await this.assertMatch(this.userId);

    return this.$store.dispatch('getUserData', this.userId)
      .catch((err) => {
        const errorMessage = 'Error in getting data. Please try again later.';
        console.error(errorMessage, err);
        this.$toasted.global.appError({ errorMessage });
        this.error = errorMessage;
      })
      .then(async (user) => {
        if (!user) return false;
        this.user = user;
        this.loading = false;
        this.error = undefined;
        return user;
      });
  },
};
</script>

<style>

</style>
